import React from 'react';
import PropTypes from 'prop-types';
import postal from 'postal';

export default class Header extends React.Component {
  static propTypes = {
    categoryName: PropTypes.string,
    seriesTitle: PropTypes.string,
    isSponsored: PropTypes.bool,
  }

  static defaultProps = {
    categoryName: '',
    seriesTitle: '',
    isSponsored: false,
  }

  constructor(props, context) {
    super(props, context);

    this.state = {
      categoryName: this.props.categoryName,
      seriesTitle: this.props.seriesTitle,
      isSponsored: this.props.isSponsored,
    };
  }

  componentDidMount() {
    postal.subscribe({
      channel: 'editor',
      topic: 'category-changed',
      callback: categoryName => {
        this.setState({ categoryName });
      },
    });

    postal.subscribe({
      channel: 'editor',
      topic: 'collections-changed',
      callback: seriesTitle => {
        this.setState({ seriesTitle });
      },
    });

    postal.subscribe({
      channel: 'editor',
      topic: 'is-sponsored-changed',
      callback: isSponsored => {
        this.setState({ isSponsored });
      },
    });
  }

  category() {
    return this.state.seriesTitle || this.state.categoryName;
  }

  render() {
    return (
      <h5 className="caption">
        { this.category() && (<span className="main">{ this.category() }</span>) }
        { this.category() && this.state.isSponsored && (<span className="separator">•</span>) }
        { this.state.isSponsored && (<span className="secondary">sponsored</span>) }
      </h5>
    );
  }
}
